export const convertCamelCaseIntoSnakeCase = (str: string): string =>
	str.replace(/[A-Z]/g, (char) => `_${char.toLowerCase()}`);
